/** Sufixos das colunas hora_util_inicio_* / hora_util_fim_* de configuracoes, de segunda a domingo. */
const DIAS_HORARIO_UTIL = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];

const state = () => {
    let persisted = JSON.parse(sessionStorage.getItem('config'));
    return persisted ? {
        ...persisted,
        limite_linhas_exportacao_csv_local: Number(persisted.limite_linhas_exportacao_csv_local) > 0
            ? Number(persisted.limite_linhas_exportacao_csv_local)
            : 1000,
        ticketCamposCriacao: persisted.ticketCamposCriacao || [],
        ticketCamposDetalhe: persisted.ticketCamposDetalhe || []
    } : {
        guias_automaticas: null,
        usar_guias: null,
        limite_tempo_parado: null,
        atraso_minimo_viagens_previstas: null,
        limite_adiantamento_viagem_prevista: null,
        limite_tempo_viagem_menor: null,
        limite_tempo_largada: null,
        hora_inicial_dia_operacao: null,
        hora_inicial_dia_financeiro: null,
        distancia_limite_comboio: null,
        tempo_ciclo_comboio: null,
        intervalo_posicoes_comboio: null,
        tempo_fechamento_automatico: null,
        monitor_roleta_obrigatoria: null,
        monitor_odometro_obrigatorio: null,
        ligar_filtros_roleta: null,
        ligar_filtros_odometro: null,
        porcentagem_diferenca_odometro: null,
        porcentagem_diferenca_roleta: null,
        numero_digitos_roleta: null,
        tempo_atualizacao_notificacoes: null,
        tempo_atualizacao_linhas: null,
        tempo_atualizacao_grade: null,
        raio_cerca_padrao: null,
        limite_atraso_cerca_padrao: null,
        limite_adiantamento_cerca_padrao: null,
        permitir_cadastro_passageiros: null,
        space_id_padrao_googlechat: null,
        lat_default: null,
        lng_default: null,
        raio_centro_unidades: null,
        tempo_busca_fixo_parada_segundos: null,
        tempo_busca_por_passageiro_segundos: null,
        tempo_desembarque_fixo_parada_segundos: null,
        tempo_desembarque_por_passageiro_segundos: null,
        tempo_maximo_permanencia_linha_minutos: null,
        velocidade_media_estimativa_kmh: null,
        max_linhas_retorno_validacao: null,
        motorista_inicio_jornada_obrigatorio: null,
        motorista_permite_abrir_guia_fora_cerca: null,
        motorista_tipos_cerca_abrir_guia: null,
        motorista_checkout_minutos_apos_checkin: null,
        limite_linhas_exportacao_csv_local: 1000,
        hora_util_inicio_segunda: null,
        hora_util_fim_segunda: null,
        hora_util_inicio_terca: null,
        hora_util_fim_terca: null,
        hora_util_inicio_quarta: null,
        hora_util_fim_quarta: null,
        hora_util_inicio_quinta: null,
        hora_util_fim_quinta: null,
        hora_util_inicio_sexta: null,
        hora_util_fim_sexta: null,
        hora_util_inicio_sabado: null,
        hora_util_fim_sabado: null,
        hora_util_inicio_domingo: null,
        hora_util_fim_domingo: null,
        ticketCamposCriacao: [],
        ticketCamposDetalhe: []
    }
}
const getters = {
    allConfig: (state) => {
        return state;
    },
    guiasAutomaticas: (state) => {
        return state.guias_automaticas;
    },
    usarGuias: (state) => {
        return state.usar_guias;
    },
    limiteTempoParado: (state) => {
        return state.limite_tempo_parado;
    },
    limiteAtrasoViagemPrevista: (state) => {
        return state.atraso_minimo_viagens_previstas;
    },
    limiteAdiantamentoViagemPrevista: (state) => {
        return state.limite_adiantamento_viagem_prevista;
    },
    limiteTempoViagemMenor: (state) => {
        return state.limite_tempo_viagem_menor;
    },
    limiteTempoLargada: (state) => {
        return state.limite_tempo_largada;
    },
    horaInicialDiaOperacao: (state) => {
        return state.hora_inicial_dia_operacao;
    },
    horaInicialDiaFinanceiro: (state) => {
        return state.hora_inicial_dia_financeiro;
    },
    distanciaLimiteComboio: (state) => {
        return state.distancia_limite_comboio;
    },
    tempoCicloComboio: (state) => {
        return state.tempo_ciclo_comboio;
    },
    intervaloPosicoesComboio: (state) => {
        return state.intervalo_posicoes_comboio;
    },
    tempoFechamentoAutomatico: (state) => {
        return state.tempo_fechamento_automatico;
    },
    monitorRoletaObrigatoria: (state) => {
        return state.monitor_roleta_obrigatoria;
    },
    monitorOdometroObrigatorio: (state) => {
        return state.monitor_odometro_obrigatorio;
    },
    ligarFiltrosRoleta: (state) => {
        return state.ligar_filtros_roleta;
    },
    ligarFiltrosOdometro: (state) => {
        return state.ligar_filtros_odometro;
    },
    porcentagemDiferencaOdometro: (state) => {
        return state.porcentagem_diferenca_odometro;
    },
    porcentagemDiferencaRoleta: (state) => {
        return state.porcentagem_diferenca_roleta;
    },
    numeroDigitosRoleta: (state) => {
        return state.numero_digitos_roleta;
    },
    tempoAtualizacaoNotificacoes: (state) => {
        return state.tempo_atualizacao_notificacoes;
    },
    tempoAtualizacaoNotificacoesAjustado: (state) => {
        return state.tempo_atualizacao_notificacoes * 1000 || 60000;
    },
    tempoAtualizacaoLinhas: (state) => {
        return state.tempo_atualizacao_linhas;
    },
    tempoAtualizacaoLinhasAjustado: (state) => {
        return state.tempo_atualizacao_linhas * 1000 || 300000;
    },
    tempoAtualizacaoGrade: (state) => {
        return state.tempo_atualizacao_grade;
    },
    tempoAtualizacaoGradeAjustado: (state) => {
        return state.tempo_atualizacao_grade * 1000 || 120000;
    },
    raioCercaPadrao: (state) => {
        return state.raio_cerca_padrao;
    },
    limiteAtrasoCercaPadrao: (state) => {
        return state.limite_atraso_cerca_padrao;
    },
    limiteAdiantamentoCercaPadrao: (state) => {
        return state.limite_adiantamento_cerca_padrao;
    },
    permitirCadastroPassageiros: (state) => {
        return state.permitir_cadastro_passageiros;
    },
    spaceIdPadraoGooglechat: (state) => {
        return state.space_id_padrao_googlechat;
    },
    centerDefault: (state) => {
        return [state.lat_default, state.lng_default];
    },
    ticketCamposCriacao: (state) => state.ticketCamposCriacao || [],
    ticketCamposCriacaoForScreen: (state) => (screen) => {
        const list = state.ticketCamposCriacao || [];
        return list
            .filter((row) => row.tela === screen && (row.ativo === 1 || row.ativo === '1'))
            .map((row) => row.campo);
    },
    ticketCamposDetalhe: (state) => state.ticketCamposDetalhe || [],
    ticketCamposDetalheForScreen: (state) => (screen) => {
        const list = state.ticketCamposDetalhe || [];
        return list
            .filter((row) => row.tela === screen && (row.ativo === 1 || row.ativo === '1'))
            .map((row) => row.campo);
    },
    motoristaInicioJornadaObrigatorio: (state) => {
        return state.motorista_inicio_jornada_obrigatorio;
    },
    motoristaPermiteAbrirGuiaForaCerca: (state) => {
        return state.motorista_permite_abrir_guia_fora_cerca;
    },
    motoristaCheckoutMinutosAposCheckin: (state) => {
        return state.motorista_checkout_minutos_apos_checkin;
    },
    limiteLinhasExportacaoCsvLocal: (state) => {
        const limite = Number(state.limite_linhas_exportacao_csv_local);
        return Number.isInteger(limite) && limite > 0 ? limite : 1000;
    },
    /** Limite global de permanência na linha, em minutos; null quando a regra está desligada. */
    tempoMaximoPermanenciaLinha: (state) => {
        const minutos = Number(state.tempo_maximo_permanencia_linha_minutos);
        return Number.isFinite(minutos) && minutos > 0 ? Math.floor(minutos) : null;
    },
    /** Linhas retornadas por pessoa na validação; sem valor configurado vale o padrão 5. */
    maxLinhasRetornoValidacao: (state) => {
        const n = Number(state.max_linhas_retorno_validacao);
        return Number.isInteger(n) && n > 0 ? Math.min(n, 20) : 5;
    },
    /**
     * Horário útil (Configurações > Horário útil) do dia da semana de `date`: { inicio, fim } em 'HH:mm',
     * ou null quando o dia não tem horário útil.
     */
    horarioUtil: (state) => (date) => {
        const dia = DIAS_HORARIO_UTIL[(date.getDay() + 6) % 7];
        const inicio = state[`hora_util_inicio_${dia}`];
        const fim = state[`hora_util_fim_${dia}`];
        return inicio && fim ? { inicio, fim } : null;
    },
    /** Velocidade média global de estimativa, em km/h; null quando não há estimativa. */
    velocidadeMediaEstimativa: (state) => {
        const kmh = Number(state.velocidade_media_estimativa_kmh);
        return Number.isFinite(kmh) && kmh > 0 ? Math.floor(kmh) : null;
    },
}

const mutations = {
    setConfig(state, config) {
        state.guias_automaticas = config.guias_automaticas != 0;
        state.usar_guias = config.usar_guias != 0;
        state.limite_tempo_parado = config.limite_tempo_parado;
        state.atraso_minimo_viagens_previstas = config.atraso_minimo_viagens_previstas;
        state.limite_adiantamento_viagem_prevista = config.limite_adiantamento_viagem_prevista;
        state.limite_tempo_viagem_menor = config.limite_tempo_viagem_menor;
        state.limite_tempo_largada = config.limite_tempo_largada;
        state.hora_inicial_dia_operacao = config.hora_inicial_dia_operacao;
        state.hora_inicial_dia_financeiro = config.hora_inicial_dia_financeiro;
        state.distancia_limite_comboio = config.distancia_limite_comboio;
        state.tempo_ciclo_comboio = config.tempo_ciclo_comboio;
        state.intervalo_posicoes_comboio = config.intervalo_posicoes_comboio;
        state.tempo_fechamento_automatico = config.tempo_fechamento_automatico;
        state.monitor_roleta_obrigatoria = config.monitor_roleta_obrigatoria != 0;
        state.monitor_odometro_obrigatorio = config.monitorOdometroObrigatorio != 0;
        state.ligar_filtros_roleta = config.ligar_filtros_roleta != 0;
        state.ligar_filtros_odometro = config.ligar_filtros_odometro != 0;
        state.porcentagem_diferenca_roleta = config.porcentagem_diferenca_roleta;
        state.porcentagem_diferenca_odometro = config.porcentagem_diferenca_odometro;
        state.numero_digitos_roleta = config.numero_digitos_roleta;
        state.tempo_atualizacao_notificacoes = config.tempo_atualizacao_notificacoes;
        state.tempo_atualizacao_linhas = config.tempo_atualizacao_linhas;
        state.tempo_atualizacao_grade = config.tempo_atualizacao_grade;
        state.raio_cerca_padrao - config.raio_cerca_padrao;
        state.limite_atraso_cerca_padrao = config.limite_atraso_cerca_padrao;
        state.limite_adiantamento_cerca_padrao = config.limite_adiantamento_cerca_padrao;
        state.permitir_cadastro_passageiros = config.permitir_cadastro_passageiros != 0;
        state.space_id_padrao_googlechat = config.state_id_padrao_googlechat;
        state.lat_default = config.lat_default;
        state.lng_default = config.lng_default;
        state.raio_centro_unidades = config.raio_centro_unidades;
        state.tempo_busca_fixo_parada_segundos = config.tempo_busca_fixo_parada_segundos;
        state.tempo_busca_por_passageiro_segundos = config.tempo_busca_por_passageiro_segundos;
        state.tempo_desembarque_fixo_parada_segundos = config.tempo_desembarque_fixo_parada_segundos;
        state.tempo_desembarque_por_passageiro_segundos = config.tempo_desembarque_por_passageiro_segundos;
        state.tempo_maximo_permanencia_linha_minutos = config.tempo_maximo_permanencia_linha_minutos;
        state.velocidade_media_estimativa_kmh = config.velocidade_media_estimativa_kmh;
        state.max_linhas_retorno_validacao = config.max_linhas_retorno_validacao;
        state.motorista_inicio_jornada_obrigatorio = config.motorista_inicio_jornada_obrigatorio;
        state.motorista_permite_abrir_guia_fora_cerca = config.motorista_permite_abrir_guia_fora_cerca;
        state.motorista_tipos_cerca_abrir_guia = config.motorista_tipos_cerca_abrir_guia;
        state.motorista_checkout_minutos_apos_checkin = config.motorista_checkout_minutos_apos_checkin;
        state.limite_linhas_exportacao_csv_local =
            Number.isInteger(Number(config.limite_linhas_exportacao_csv_local)) &&
            Number(config.limite_linhas_exportacao_csv_local) > 0
                ? Number(config.limite_linhas_exportacao_csv_local)
                : 1000;
        DIAS_HORARIO_UTIL.forEach((dia) => {
            state[`hora_util_inicio_${dia}`] = config[`hora_util_inicio_${dia}`] || null;
            state[`hora_util_fim_${dia}`] = config[`hora_util_fim_${dia}`] || null;
        });
        sessionStorage.setItem('config', JSON.stringify(state));
    },
    setTicketCamposCriacao(state, list) {
        state.ticketCamposCriacao = Array.isArray(list) ? list : [];
        sessionStorage.setItem('config', JSON.stringify(state));
    },
    setTicketCamposDetalhe(state, list) {
        state.ticketCamposDetalhe = Array.isArray(list) ? list : [];
        sessionStorage.setItem('config', JSON.stringify(state));
    }
}

const actions = {
    async fetchTicketCamposCriacao({ state, commit }) {
        if (state.ticketCamposCriacao && state.ticketCamposCriacao.length > 0) return;
        try {
            const { default: axios } = await import('axios');
            const { ApiBaseUrl } = await import('@/constants');
            const token = sessionStorage.getItem('api');
            const res = await axios.get(ApiBaseUrl + '/api/v1.0/getTicketCamposCriacao', {
                headers: { 'x-access-token': token }
            });
            const list = Array.isArray(res.data) ? res.data : [];
            list.forEach(row => {
                if (row.ativo !== undefined && row.ativo !== null) row.ativo = Number(row.ativo) ? 1 : 0;
            });
            commit('setTicketCamposCriacao', list);
        } catch (e) {
            console.warn('fetchTicketCamposCriacao', e);
        }
    },
    async fetchTicketCamposDetalhe({ state, commit }) {
        if (state.ticketCamposDetalhe && state.ticketCamposDetalhe.length > 0) return;
        try {
            const { default: axios } = await import('axios');
            const { ApiBaseUrl } = await import('@/constants');
            const token = sessionStorage.getItem('api');
            const res = await axios.get(ApiBaseUrl + '/api/v1.0/getTicketCamposDetalhe', {
                headers: { 'x-access-token': token }
            });
            const list = Array.isArray(res.data) ? res.data : [];
            list.forEach(row => {
                if (row.ativo !== undefined && row.ativo !== null) row.ativo = Number(row.ativo) ? 1 : 0;
            });
            commit('setTicketCamposDetalhe', list);
        } catch (e) {
            console.warn('fetchTicketCamposDetalhe', e);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}